// extracted by mini-css-extract-plugin
module.exports = {"footer":"CodeVerificationSideSheet_footer__JyF2N","snackBarContainer":"CodeVerificationSideSheet_snackBarContainer__FmYaQ"};